import { render } from "./CloseButton.vue?vue&type=template&id=5ebada8b"
import script from "./CloseButton.vue?vue&type=script&lang=js"
export * from "./CloseButton.vue?vue&type=script&lang=js"

import "./CloseButton.vue?vue&type=style&index=0&id=5ebada8b&lang=css"
script.render = render

export default script